import { HTTP as http } from '../../http'

const PREFIX = '/address'

export default {
    getAllAddress: () => {
        return http.post(PREFIX+'/getAllAddress')
    },

    getAddress: (address_id) => {
        return http.get(PREFIX+'/getAddress/'+address_id)
    },

    create: (data) => {
        return http.post(PREFIX+'/create', data)
    },

    update: (data) => {
        return http.post(PREFIX+'/update', data)
    },

    setMain: (data) => {
        return http.post(PREFIX+'/setMain', data)
    },

    getMainAddress: () => {
         return http.get(PREFIX+'/getMainAddress')
    }
}